import { Select } from '@mantine/core'
import type { ComboboxItem, SelectProps } from '@mantine/core'

export type CompanyOption = { companyId: string; companyName: string }

type CompanySelectProps = Omit<
  SelectProps,
  'data' | 'renderOption' | 'filter' | 'searchable'
> & {
  companies: CompanyOption[]
}

const matches = (option: ComboboxItem, search: string) => {
  const needle = search.trim().toLowerCase()
  return (
    option.label.toLowerCase().includes(needle) ||
    option.value.toLowerCase().includes(needle)
  )
}

const CompanySelect = ({ companies, ...props }: CompanySelectProps) => (
  <Select
    searchable
    data={companies.map((company) => ({
      value: company.companyId,
      label: company.companyName,
    }))}
    filter={({ options, search }) =>
      (options as ComboboxItem[]).filter((option) => matches(option, search))
    }
    renderOption={({ option }) => (
      <div className="flex min-w-0 flex-col">
        <span className="text-xs font-medium text-doubleNickel-gray-800">
          {option.label}
        </span>
        <span className="font-mono text-[11px] text-doubleNickel-gray-500">
          {option.value}
        </span>
      </div>
    )}
    nothingFoundMessage="No company matches"
    {...props}
  />
)

export default CompanySelect
